<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="web/equipment/maintain/standard/group/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('baoyangfenzu')" rexiauired>
            <el-input type="text" v-model="yt.conditions.group"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
          </el-form-item>
          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          v-if="utils.checkPower('web_base_maintain_standard_group_create')"
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w1');
            setDefaultValue();
          "
          type="primary"
        >
          {{ $t('xinzeng') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_base_maintain_standard_reset')" size="mini" @click="yt.showEditDialog('chongzhibaoyangbiaozhun', null, '80%')" plain>
          {{ $t('chongzhibaoyangbiaozhun') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_base_maintain_standard_batch_import_group_and_detail')" size="mini" @click="showImportExcelGroupDetail = !showImportExcelGroupDetail" plain>
          {{ $t('daorubaoyangfenzu-mingxi') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_base_maintain_standard_batch_import_group_and_equipment')" size="mini" @click="showImportExcelGroupEquipment = !showImportExcelGroupEquipment" plain>
          {{ $t('daorubaoyangfenzu-shebei') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="utils.checkPower('web_base_maintain_standard_group_update')">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row);">
							{{$t('bianji')}}
						</el-button>
					</el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_base_maintain_standard_group_item')">
            <el-button type="text" @click="yt.showEditDialog('baoyangmingxi', scope.row, '60%')">
              {{ $t('baoyangmingxi') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_base_maintain_standard_group_equipment')">
            <el-button type="text" @click="yt.showEditDialog('shebei', scope.row, '40%')">
              {{ $t('shebei') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_base_maintain_standard_delete')">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/equipment/maintain/standard/group/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <template #baoyangdanshengchengguize="scope">
				 <p>
					{{$t(store.state.dictJson['MAINTENANCE_ORDER_GENERATION_RULES'][scope.row.generationRules])}}
				 </p>
			</template>
      <!-- <template #baoyangdanshengchengtiqiantianshu="scope">
				 <p>
					{{scope.row.advanceDays==0 || scope.row.advanceDays==null ? null : scope.row.advanceDays }}
				 </p>
			</template> -->
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('baoyangfenzu')" required>
            <el-input type="text" v-model="yt.editObj.group" size="mini"></el-input>
          </el-form-item>
          <el-form-item :label="$t('baoyangdanshengchengguize')" size="mini" required>
          <yi_dictionary_select :max="1" :type="'MAINTENANCE_ORDER_GENERATION_RULES'" :ids.sync="yt.editObj.generationRules">
          </yi_dictionary_select>
        </el-form-item>
        <el-form-item :label="$t('baoyangdanshengchengtiqiantianshu')">
          <yi_number_input :type="'number'" :start.sync="yt.editObj.advanceDays" :min="0" :max="365">
          </yi_number_input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/equipment/maintain/standard/group/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('baoyangfenzu')" required>
            <el-input disabled type="text" v-model="yt.editObj.group" size="mini"></el-input>
          </el-form-item>
          <el-form-item :label="$t('baoyangdanshengchengguize')" size="mini" required>
          <yi_dictionary_select :max="1" :type="'MAINTENANCE_ORDER_GENERATION_RULES'" :ids.sync="yt.editObj.generationRules">
          </yi_dictionary_select>
        </el-form-item>
        <el-form-item :label="$t('baoyangdanshengchengtiqiantianshu')">
          <yi_number_input type="number" :start.sync="yt.editObj.advanceDays" :min="0" :max="365">
          </yi_number_input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/equipment/maintain/standard/group/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 保养明细弹窗 -->
      <template v-if="yt.editObj.action == 'baoyangmingxi'">
        <div class="dialog-scroller">
          <standard_group_item :group="yt.editObj"></standard_group_item>
        </div>
      </template>
      <!-- 设备弹窗 -->
      <template v-if="yt.editObj.action == 'shebei'">
        <div class="dialog-scroller">
          <standard_group_equipment :group="yt.editObj"></standard_group_equipment>
        </div>
      </template>
      <template v-if="yt.editObj.action == 'chongzhibaoyangbiaozhun'">
        <div class="dialog-scroller">
          <yi_cross_select :component="'web_base_equipment_list'" :max="200" multiple :ids.sync="yt.editObj.equipmentIds" :isInput="false"></yi_cross_select>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/equipment/maintain/standard/group/reset')" type="primary">
            {{ $t('quedingchongzhi') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <import_excel_group_detail :show.sync="showImportExcelGroupDetail" />
    <import_excel_group_equipment :show.sync="showImportExcelGroupEquipment" />
  </div>
</template>

<script>
import shift_setting from '@@/pages/web/base/shift/shift_setting';
import standard_group_item from '@@/pages/web/base/maintain_standard/group_standard_group_item';
import standard_group_equipment from '@@/pages/web/base/maintain_standard/group_standard_group_equipment';
import import_excel_group_detail from '@@/pages/web/base/maintain_standard/import_excel_group_detail';
import import_excel_group_equipment from '@@/pages/web/base/maintain_standard/import_excel_group_equipment';
export default {
  name: 'web_base_maintain_standard_group_list',
  components: {
    shift_setting,
    standard_group_item,
    standard_group_equipment,
    import_excel_group_detail,
    import_excel_group_equipment
  },
  created() {
    setTimeout(() => {
      this.utils.event_hub.$on('EQUIPMENT_MATERIAL_STANDARD_GROUP', () => {
        this.yt.get(1);
      });
      this.yt.get(1);
    }, 300);
  },
  data() {
    return {
      options: [
        {
          label: this.$t('nian'),
          value: 1
        },
        {
          label: this.$t('yue'),
          value: 2
        },
        {
          label: this.$t('zhou'),
          value: 3
        },
        {
          label: this.$t('tian'),
          value: 4
        }
      ],
      list: [],
      organizationList: [],
      customerList: [],
      shiftList: [],
      maintainTypeList: [],
      showImportExcelGroupDetail: false,
      showImportExcelGroupEquipment: false,
      
      columns: [
        {
          label: 'baoyangfenzu',
          prop: 'group'
        },
        {
          label: 'baoyangdanshengchengguize',
          type: 'slot',
        },{
          label: 'baoyangdanshengchengtiqiantianshu',
          prop: 'advanceDays',
        },
        {
          label: 'caozuo',
          type: 'slot'
        }
      ],
      isShowAddCycleDialog: false,
      isShowEditCycleDialog: false,
      labelWidth: '100px',
      timeList: []
    };
  },
  methods: {
    setDefaultValue(){
      this.yt.editObj.generationRules = '0';
      //设置默认值  
      // this.yt.editObj.group = this.$t('baoyangfenzu') + ' ' + this.list.length;
      
    }
    
  }
};
</script>
